<template>
  <div class="content">
    <div style="display: none!important;">
      <electron-vue-printer
        ref="electronVuePrinter"
        :show="true"
        :options="options"
        :rotateType="rotateType"
        @webview-ready="Printer"
        @start-printing="Starprinting"
        :silent="true"
      >
      </electron-vue-printer>
    </div>
    {{print}}
    <div id="my-node">
      <h5>
        <span>
          <b>{{ Datetime() }}</b>
        </span>
        <span style="float: right;">
          <b>{{username}}</b>
        </span>
      </h5>
      <h5 class="text-center">
        <b>{{ $t("Савдо") }}</b>
      </h5>
      <table class="table table-borderless table-sm text-center">
        <tbody>
          <tr>
            <td><b>{{$t("Нақд")}} $</b></td>
            <td><b>{{datas.rasxod.dollar |numFormat}}</b></td>
          </tr>
          <tr>
            <td><b>{{$t("Нақд")}}</b></td>
            <td><b>{{datas.rasxod.cash |numFormat}}</b></td>
          </tr>
          <tr>
            <td><b>{{$t("Пластик")}}</b></td>
            <td><b>{{datas.rasxod.plastic |numFormat}}</b></td>
          </tr>
        </tbody>
      </table>
      <h5 class="text-center mt-2">
        <b>{{ $t("Клиент тўлови") }}</b>
      </h5>
      <table class="table table-borderless table-sm text-center">
        <tbody>
          <tr>
            <td><b>{{$t("Нақд")}} $</b></td>
            <td><b>{{datas.kontragent_pay.dollar|numFormat}}</b></td>
          </tr>
          <tr>
            <td><b>{{$t("Нақд")}}</b></td>
            <td><b>{{datas.kontragent_pay.cash|numFormat}}</b></td>
          </tr>
          <tr>
            <td><b>{{$t("Пластик")}}</b></td>
            <td><b>{{datas.kontragent_pay.plastic|numFormat}}</b></td>
          </tr>
        </tbody>
      </table>
      <h5 class="text-center mt-2">
        <b>{{$t("Возврат")}}</b>
      </h5>
      <table class="table table-borderless table-sm text-center">
        <tbody>
          <tr>
            <td><b>{{$t("Нақд")}} $</b></td>
            <td><b>{{datas.refund.dollar|numFormat}}</b></td>
          </tr>
          <tr>
            <td><b>{{$t("Нақд")}}</b></td>
            <td><b>{{datas.refund.cash|numFormat}}</b></td>
          </tr>
          <tr>
            <td><b>{{$t("Пластик")}}</b></td>
            <td><b>{{datas.refund.plastic|numFormat}}</b></td>
          </tr>
        </tbody>
      </table>
      <ul>
        <li>
          <b>{{ $t("Жами") }} {{ $t("Нақд") }}:</b>
          <b style="float: right;">{{ allcash|numFormat }}</b>
        </li>
      </ul>
      <ul>
        <li>
          <b>{{ $t("Жами") }} {{ $t("Нақд") }} $:</b>
          <b style="float: right;">{{ alldollar|numFormat }}</b>
        </li>
      </ul>
      <ul>
        <li>
          <b>{{ $t("Жами") }} {{ $t("Пластик") }}:</b>
          <b style="float: right;">{{ allplastic|numFormat }}</b>
        </li>
      </ul>
      <ul>
        <li>
          <b>***</b>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import * as htmlToImage from "html-to-image";
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
import electronVuePrinter from "electron-vue-printer";
export default {
  name: "Print",
  components: { electronVuePrinter, htmlToImage },
  data() {
    return {
      print:'false',
      printer: '',
      datas: null,
      allcash: 0,
      allplastic: 0,
      alldollar: 0,
      rotateType: 0,
      username: localStorage.getItem("username"),
      options: {
        offsetX: 0,
        offsetY: 0,
        imageWidth: 300
      }
    };
  },
  async updated(){
    if(this.print=='print'){
      this.$refs.electronVuePrinter.deviceNamePrint = this.printer.check_printer_name;
      await this.$refs.electronVuePrinter.print(this.dataUrl);
    }
  },
  created: function() {
    this.GetPrinterName();
    this.datas = JSON.parse(localStorage.getItem("zreportcheck"));
    this.allcash = JSON.parse(localStorage.getItem("allcash"));
    this.allplastic = JSON.parse(localStorage.getItem("allplastic"));
    this.alldollar = JSON.parse(localStorage.getItem("alldollar"));
    this.print=true;
  },
  methods: {
    Starprinting(data){
      if(data==true){
        setTimeout(() => {
          localStorage.removeItem("zreportcheck");
          localStorage.removeItem("allcash");
          localStorage.removeItem("allplastic");
          localStorage.removeItem("alldollar");
          window.close();
        }, 1000);
      }
    },
    async Printer() {
      let self = this;
      var node = document.getElementById("my-node");
     await htmlToImage
        .toSvg(document.getElementById("my-node"))
        .then(function(dataUrl) {
          self.dataUrl=dataUrl;
            self.print='print';            
        })
        .catch(function(error) {
          console.error("oops, something went wrong!", error);
        });
    },
    GetPrinterName(){
      let self = this;
      axios({
        method: "post",
        url: "api/v1/sklad-settings",
        data: { sklad_id: localStorage.getItem('sklad_id'), key: 'a4_printer' }
      }).then(function (response) {
        if (response.data.data != null) {
          self.printer = JSON.parse(response.data.data);
        }
      });
    },
    Datetime() {
      var d = new Date();
      var dt = d.getDate();
      var month = d.getMonth() + 1;
      var hour = d.getHours();
      var minut = d.getMinutes();
      var sekund = d.getSeconds();
      if (month < 10) {
        month = "0" + month;
      }
      if (dt < 10) {
        dt = "0" + dt;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minut < 10) {
        minut = "0" + minut;
      }
      if (sekund < 10) {
        sekund = "0" + sekund;
      }

      return dt + "." + month + "." + d.getFullYear() + " " + hour+":"+minut+":"+sekund;
    }
  }
};
</script>
<style scoped>
#my-node {
  width: 300px;
}

h5 {
  font-weight: bold;
  font-size: 14px;
  color: black;
}

ul {
  list-style: none;
  border-bottom: 1px dotted;
  text-align: left;
  padding: 0;
  margin: 0;
  font-size: 13px;
  color: black;
}
</style>
